import { configureStore } from '@reduxjs/toolkit';
import { IS_PRODUCTION } from '../env';
import { channelApi, graphqlApiWithPersisted, rootApi } from '../services';
import { sentryReduxEnhancer } from '../shared';
import { rootReducer } from './rootReducer';

export const store = configureStore({
  enhancers: [sentryReduxEnhancer],
  devTools: !IS_PRODUCTION,
  reducer: rootReducer,
  middleware: (getdefaultMiddleware) =>
    getdefaultMiddleware().concat([
      rootApi.middleware,
      channelApi.middleware,
      graphqlApiWithPersisted.middleware,
    ]),
});

export type RootStore = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
